<script>
	import * as tf from '@tensorflow/tfjs';
  import loader from "./async-loader";
  import { onMount } from "svelte";
  import tensorAsBase64 from "tensor-as-base64";
  import Slider from "svelte-compare-image-slider";
  import Dropzone from "svelte-file-dropzone";
  import Loader from "./Loader.svelte";


  const img = new Image();
  const img2 = new Image();

  var loading = false;
  var showOutput = false;
  var inputSrc = "";
  var outputSrc = "";

  onMount(()=>{
    // tf.ENV.set('WEBGL_PACK', false);
    document.getElementById("show-image").appendChild(img);
    document.getElementById("show-image").appendChild(img2);
  });

	async function predict(){
    if (loading) return;
    loading = true;
		const model = await tf.loadLayersModel('model/model.json');
    const inputImage = document.getElementById("input-image");
    const tensor = tf.browser.fromPixels(inputImage).expandDims(0);
		const prediction = model.predict(tensor).squeeze();
    outputSrc = await tensorAsBase64(prediction);
    loading = false;
    showOutput = true;
	}


  let files = {
    accepted: [],
    rejected: []
  };

  function handleFilesSelect(e) {
    const { acceptedFiles, fileRejections } = e.detail;
    files.accepted = [...files.accepted, ...acceptedFiles];
    files.rejected = [...files.rejected, ...fileRejections];
    showOutput = false;
    inputSrc = URL.createObjectURL(acceptedFiles[0]);
  }
</script>



<div class="container">
  <div style="display: flex;">
    <h1 class="heading">Upscale your image.</h1>
  </div>

  <Dropzone on:drop={handleFilesSelect} multiple=false accept="image/*" containerStyles="color: #8f87b6b6; background-color: #302b52; border-color: #8f87b696;"/>
  <div id="show-image">
    {#if showOutput}
      <div style="margin-bottom: 20px;">
        <Slider leftImage="{inputSrc}" rightImage="{outputSrc}"/>
      </div>
    {:else}
      <img id="input-image" src="{inputSrc}" style={inputSrc == "" ? "" : "margin: 20px 0;"} />
    {/if}
  </div>

  <div style="display: flex; flex-direction: row;">
    <button class="predict-btn" on:click={predict}>
    {#if loading}
      <Loader />
    {:else}
      Upscale
    {/if}
  </button>
  {#if showOutput}
    <a class="download-btn" href="{outputSrc}" download="upscaled-image.png">Download</a>
  {/if}
  </div>
</div>




<style>
  .predict-btn {
    background-color: transparent;
    color: white;
    border-radius: 20px;
    width: 100px;
    height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-color: #8f87b6b6;
    align-items: center;
    outline: none;
    cursor: pointer;
    margin-right: 20px;
  }

  .download-btn {
    background-color: white;
    color: #272343;
    border-radius: 20px;
    width: 100px;
    height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    outline: none;
    cursor: pointer;
    text-decoration: none;
  }


  .heading {
    color: white;
  }

  .container {
    width: 600px;
  }
</style>